import pluginTypes from 'constants/pluginTypes';
import messages from './messages';

const configDefault = {
  title: messages.title,
  description: messages.description,
  placeholder: messages.placeholder,
  templateTitle: messages.templateTitle,
  templateDescription: messages.templateDescription,
  descriptionPlaceholder: messages.descriptionPlaceholder,
};

const configCourse = {
  ...configDefault,
  placeholder: messages.coursePlaceholder,
  descriptionPlaceholder: messages.courseDescriptionPlaceholder,
  title: messages.courseTitle,
};

const configUnit = {
  ...configDefault,
  placeholder: messages.unitPlaceholder,
  descriptionPlaceholder: messages.unitDescriptionPlaceholder,
  title: messages.unitTitle,
};

const configLesson = {
  ...configDefault,
  placeholder: messages.lessonPlaceholder,
  descriptionPlaceholder: messages.lessonDescriptionPlaceholder,
  title: messages.lessonTitle,
};

const configScreen = {
  ...configDefault,
  placeholder: messages.screenPlaceholder,
  descriptionPlaceholder: messages.screenDescriptionPlaceholder,
  title: messages.screenTitle,
};

const configApp = {
  ...configDefault,
  placeholder: messages.appPlaceholder,
  title: messages.appTitle,
  showDescriptionInput: false,
};

const configPathway = {
  title: messages.pathwayTitle,
  placeholder: messages.pathwayPlaceholder,
};

const getConfig = (type) => {
  switch (type) {
    case pluginTypes.COURSE:
      return configCourse;
    case pluginTypes.LESSON:
      return configLesson;
    case pluginTypes.UNIT:
      return configUnit;
    case pluginTypes.SCREEN:
      return configScreen;
    case pluginTypes.PATHWAY:
      return configPathway;
    case pluginTypes.APP:
      return configApp;
    default:
      return configDefault;
  }
};

const config2ndStepCourse = {
  title: messages.choosePathwayTypes,
  description: messages.courseChoosePathwayTypesDescription,
};

const config2ndStepUnit = {
  title: messages.choosePathwayTypes,
  description: messages.unitChoosePathwayTypesDescription,
};

const config2ndStepLesson = {
  title: messages.choosePathwayTypes,
  description: messages.lessonChoosePathwayTypesDescription,
};

const getConfig2ndStep = (type) => {
  switch (type) {
    case pluginTypes.COURSE:
      return config2ndStepCourse;
    case pluginTypes.UNIT:
      return config2ndStepUnit;
    case pluginTypes.LESSON:
      return config2ndStepLesson;
    default:
      return undefined;
  }
};

export default getConfig;
export { getConfig2ndStep };
